import { createEvent, createStore } from 'effector';

interface PdfViewerState {
  fileUrl: string;
  fileName: string;
  isOpen: boolean;
}
export const initialPdfViewerState: PdfViewerState = {
  fileUrl: '',
  fileName: '',
  isOpen: false,
};

export const $pdfViewerState = createStore(initialPdfViewerState);
export const openPdfViewerEvent = createEvent<PdfViewerState>();
$pdfViewerState.on(openPdfViewerEvent, (state, values) => {
  return { ...state, ...values };
});
export const closePdfViewerEvent = createEvent();
$pdfViewerState.on(closePdfViewerEvent, () => {
  return { fileUrl: '', fileName: '', isOpen: false };
});
